// Module
var code = `<div class="member-photo"> <ul class="list-unstyled hidden-xs text-right"> <li><strong>{{ photoController.person.displayName }}</strong></li> <li>{{ photoController.member.type.names | description }}</li> </ul> <img ng-src="{{ photoController.person.photoUrl }}" aria-hidden="true" class="img-circle"/> </div> `;
// Exports
module.exports = code;